import { render, staticRenderFns } from "./CompanyListTemplate.vue?vue&type=template&id=a0a8e74a"
import script from "./CompanyListTemplate.vue?vue&type=script&lang=js"
export * from "./CompanyListTemplate.vue?vue&type=script&lang=js"
import style0 from "./CompanyListTemplate.vue?vue&type=style&index=0&id=a0a8e74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports